// ResizeObserver ponyfill — bundled, not CDN.
//
// Older browsers (notably older iPad Safari) lack a native ResizeObserver, and
// the app previously pulled the polyfill from cdn.jsdelivr.net via a <script>
// tag in index.html. Corporate proxies / CSP that block jsdelivr would leave
// ResizeObserver undefined and white-screen the whole app — MUI and our
// SignaturePad call `new ResizeObserver(...)` directly. Bundling it removes that
// external point of failure.
//
// This module performs the assignment as an import side effect, so importing it
// FIRST in the entrypoint guarantees window.ResizeObserver exists before any
// other module (App, MUI, SignaturePad) evaluates. Assign only when missing so
// modern browsers keep their native, more-performant implementation.
import ResizeObserverPolyfill from 'resize-observer-polyfill';

if (typeof window !== 'undefined' && !('ResizeObserver' in window)) {
  (window as unknown as { ResizeObserver: typeof ResizeObserverPolyfill }).ResizeObserver =
    ResizeObserverPolyfill;
}
